/*
 * A class for expressing arguments to interrupt events.
 */
export var InterruptArgs = (function () {
    function InterruptArgs(source, innerArgs, force) {
        if (force === void 0) { force = false; }
        this.source = source;
        this.innerArgs = innerArgs;
        this.force = force;
    }
    return InterruptArgs;
}());
//# sourceMappingURL=interruptargs.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@ng-idle/core/src/interruptargs.js
// module id = ../../../../@ng-idle/core/src/interruptargs.js
// module chunks = 3